import { requestBuilder } from '../../http/RequestBuilder';
import type { FreeToSpendDataItem } from '../types/FreeToSpendTypes';

export const FREE_TO_SPEND_TRANSACTIONS_QUERY_KEY =
    'getFreeToSpendTransactions';

const getFreeToSpendTransactions = requestBuilder.query<
    Record<string, FreeToSpendDataItem[]>,
    { minutesOffset: number }
>({
    endpoint: ({ minutesOffset }) =>
        `/api/holistic/free-to-spend/transactions?minutesOffset=${minutesOffset}`,
    queryKey: () => FREE_TO_SPEND_TRANSACTIONS_QUERY_KEY,
    assertResponse: (data) => {
        if (data === '') {
            throw new Error(
                'Received an empty free-to-spend transactions response',
            );
        }
    },
});

// Historical rows for the transactions sheet. Callers enable this only while
// that sheet is open so the payload is not held for the whole home session.
export const useGetFreeToSpendTransactions = (enabled = false) => {
    const minutesOffset = new Date().getTimezoneOffset();
    const { data, isLoading, isError, error, refetch } =
        getFreeToSpendTransactions({ minutesOffset }, { enabled });

    const hasTransactions =
        typeof data === 'object' && data !== null && !Array.isArray(data);

    return {
        data: hasTransactions ? data : undefined,
        isLoading,
        isError: isError || (!isLoading && data != null && !hasTransactions),
        error,
        refetch,
    };
};

export default useGetFreeToSpendTransactions;
